import React from 'react'

import styles from './CardWrapper.module.css'

type CardWrapperProps = {
  children: React.ReactNode
}

const CardWrapper = ({ children }: CardWrapperProps): JSX.Element => (
  <div className={styles.cardWrapper}>{children}</div>
)

export default CardWrapper
